(function (root, factory) {
  const value = factory();
  if (typeof module === 'object' && module.exports) module.exports = value;
  else root.C1InitialCatalog = value;
})(globalThis, function () {
  'use strict';

  // Read from the existing Shopify admin session on October 27, 2026.
  // Style/color labels: docs/initials-keychain-mapping-r2/shopify-readback.json.
  // Hex values: sealed c1-initial-customer.js palette. Screen approximations only.
  // The draft has no product type or SKUs. Cart activation is a separate gate.
  return Object.freeze({
    products: Object.freeze([
      Object.freeze({
        id: '8936843116679',
        handle: 'initials-keychain',
        productType: '',
        variants: Object.freeze([
          Object.freeze({ id: '46331101839495', sku: '', style: 'Raised', color: 'Matcha Green', colorHex: '#A3B875' }),
          Object.freeze({ id: '46331101872263', sku: '', style: 'Raised', color: 'Soft Pink', colorHex: '#EFB6C8' }),
          Object.freeze({ id: '46331101905031', sku: '', style: 'Raised', color: 'Purple', colorHex: '#7954A7' }),
          Object.freeze({ id: '46331101937799', sku: '', style: 'Raised', color: 'Almond Yellow', colorHex: '#F3DEA0' }),
          Object.freeze({ id: '46331101970567', sku: '', style: 'Raised', color: 'Light Brown', colorHex: '#B58B69' }),
          Object.freeze({ id: '46331102003335', sku: '', style: 'Raised', color: 'Milky White', colorHex: '#F6F1E7' }),
          Object.freeze({ id: '46331102036103', sku: '', style: 'Raised', color: 'Black', colorHex: '#202124' }),
          Object.freeze({ id: '46331102068871', sku: '', style: 'Raised', color: 'Lilac', colorHex: '#B6A2D6' }),
          Object.freeze({ id: '46331102101639', sku: '', style: 'Raised', color: 'Soft Blue', colorHex: '#A9CCDF' }),
          Object.freeze({ id: '46331102134407', sku: '', style: 'Raised', color: 'Brown', colorHex: '#72503E' }),
          Object.freeze({ id: '46331102167175', sku: '', style: 'Recessed', color: 'Matcha Green', colorHex: '#A3B875' }),
          Object.freeze({ id: '46331102199943', sku: '', style: 'Recessed', color: 'Soft Pink', colorHex: '#EFB6C8' }),
          Object.freeze({ id: '46331102232711', sku: '', style: 'Recessed', color: 'Purple', colorHex: '#7954A7' }),
          Object.freeze({ id: '46331102265479', sku: '', style: 'Recessed', color: 'Almond Yellow', colorHex: '#F3DEA0' }),
          Object.freeze({ id: '46331102298247', sku: '', style: 'Recessed', color: 'Light Brown', colorHex: '#B58B69' }),
          Object.freeze({ id: '46331102331015', sku: '', style: 'Recessed', color: 'Milky White', colorHex: '#F6F1E7' }),
          Object.freeze({ id: '46331102363783', sku: '', style: 'Recessed', color: 'Black', colorHex: '#202124' }),
          Object.freeze({ id: '46331102396551', sku: '', style: 'Recessed', color: 'Lilac', colorHex: '#B6A2D6' }),
          Object.freeze({ id: '46331102429319', sku: '', style: 'Recessed', color: 'Soft Blue', colorHex: '#A9CCDF' }),
          Object.freeze({ id: '46331102462087', sku: '', style: 'Recessed', color: 'Brown', colorHex: '#72503E' })
        ])
      })
    ])
  });
});
